import React from 'react'
import cx from 'classnames'

import Widget from 'common/components/Widget'

interface Props {
  icon: React.ReactNode
  text: string
  className: string
  hasNotAccess?: boolean
  onClick: () => void
}

const QuickCard = ({
  icon,
  text,
  className,
  hasNotAccess = false,
  onClick,
}: Props) => {
  return (
    <Widget
      type="table"
      className={cx('border-l-4 border-t-0 border-r-0 border-b-0', className)}
    >
      <button
        onClick={onClick}
        className="flex group place-items-center rounded-md p-4 bg-white hover:bg-coolGray-100 h-full relative"
      >
        {hasNotAccess && (
          <div className="text-coolGray-50 font-bold text-xs rounded py-0.5 px-1 bg-coolGray-500 absolute -top-2 left-4">
            Upgrade
          </div>
        )}
        <div className="text-coolGray-400 group-hover:text-orange-400 ">
          {icon}
        </div>
        <div className="text-coolGray-800 font-medium ml-4">{text}</div>
      </button>
    </Widget>
  )
}

export default QuickCard
